import React, { useContext, useEffect } from "react";
import { Typography } from "@mui/material";
import FinishStepRoot from "./FinishStep.styles";
import ClientContextLayout from "../../modules/Client/Client.context";
import { SerproService } from "../../modules/Serpro";
import { MultiStepContextLayout } from "@fac/standard-ui-lib";
import { restart } from "../../utils/utils";

export const FinishStep = () => {
    const { client } = useContext(ClientContextLayout);
    const { step } = useContext(MultiStepContextLayout);

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;
        const trySendEmail = async () => {
            try {
                await SerproService.sendEmail({
                    cnpj: client?.cnpj || "",
                    cpf: client?.cpf || "",
                    data: client?.govData || {},
                    email: client?.email || "",
                    pendencies: client?.pendencies,
                    phone: client?.phone || "",
                    totalPendencies: client?.totalPendencies?.toString() || "",
                });
                timeout = setTimeout(() => {
                    restart();
                }, 500);
            } catch (error) {
                console.error(error);
            }
        };
        if (step !== 4 || !client?.cnpj || !client?.email) return;
        trySendEmail();
        // eslint-disable-next-line consistent-return
        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [client, step]);

    return (
        <FinishStepRoot>
            <Typography variant="h1" color="white">
                Obrigado, estamos finalizando o atendimento...
            </Typography>
            <Typography variant="h2" color="white">
                Você receberá os dados das pendências por Email.
            </Typography>
        </FinishStepRoot>
    );
};

export default FinishStep;
